export default "__VITE_ASSET__DJxWkB1Q__"